import { defineComponent as _defineComponent } from 'vue'
import { ref, onMounted, onBeforeMount } from 'vue'
import { DataInstance, InviteLinks, Userspaces } from '@busy-human/opt-library';
import {meetingConstants} from "@busy-human/opt-library";
import { httpsCallable } from 'firebase/functions';
import { functions } from '@/util/firebase';
import BackButton from "../buttons/back.vue";
import { computed } from '@vue/reactivity';
import { createInviteLink } from '@/util/functions';
import { useUserspace } from '@/store/userspace';
import { useInvites } from '@/store/invites';
type Props = {
    user: DataInstance<Userspaces.Model>
}
type Emits = {
    (e: 'close'): void
}

export default /*#__PURE__*/_defineComponent({
  __name: 'rate-overlay',
  props: {
    user: null
  },
  emits: ["close"],
  setup(__props: any, { expose, emit }: { emit: ({
    (e: 'close'): void
}), expose: any, slots: any, attrs: any }) {
  expose();

const props = __props as {
    user: DataInstance<Userspaces.Model>
}
const defaults = ref({
    length: {
        min: meetingConstants.MINIMUM_LENGTH,
        max: meetingConstants.MAXIMUM_LENGTH,
        default: meetingConstants.DEFAULT_LENGTH,
    },
    price: {
        min: meetingConstants.MINIMUM_PRICE,
        max: meetingConstants.MAXIMUM_PRICE,
        default: meetingConstants.DEFAULT_PRICE,
    }
})


const loading = ref(false);
let standardMeeting = InviteLinks.Defaults()
const standardInviteLink = ref<DataInstance<InviteLinks.Model> | null>(null)
let rate = ref<number>(props.user.defaultRate?.price.amount || standardMeeting.price.amount)
const updateRate = computed({
    get() {
        return rate.value;
    },
    set(val) {
        rate.value = Math.max(Math.min(val, defaults.value.price.max), defaults.value.price.min)
    }
})
const costLength = computed(() => {
    return updateRate.value.toString().length
})
let time = ref<number>(
    props.user.defaultRate?.minutes || standardMeeting.minutes
)
const updateDuration = computed({
    get() {
        return time.value;
    },
    set(val) {
        time.value = Math.max(Math.min(val, defaults.value.length.max), defaults.value.length.min)
    }
})
const durationLength = computed(() => {
    return updateDuration.value.toString().length
})
onBeforeMount(async() => {
    let standardInviteId = props.user.standardInviteLink || null
    if(!standardInviteId)
        return
    let inviteLinks = useInvites().links;
    standardInviteLink.value = inviteLinks.filter((invite) => invite.$id === standardInviteId)?.[0] || null
    if(standardInviteLink.value){
        rate.value = standardInviteLink.value.price.amount
        time.value = standardInviteLink.value.minutes
    }else{
        await Userspaces.Collection.updateDoc(props.user.$id!, {
            standardInviteLink: null
        })
    }
})
let updateStandardMeeting = async() => {
    if(!standardInviteLink.value) return
    if(!props.user.standardInviteLink) return;
    await InviteLinks.Collection.updateDoc(props.user.standardInviteLink, {
        price: {
            amount: rate.value,
            currency: '$'
        },
        minutes: time.value,
    })
    emit('close')
}
let createStandardMeeting = async() => {
    loading.value = true
    if(standardInviteLink.value) return
    let standardInvite = InviteLinks.Defaults()
    standardInvite.name = "Standard Invite"
    standardInvite.price.amount = rate.value
    standardInvite.minutes = time.value
    standardInvite.collector = props.user.$id
    standardInvite.isStandard = true

    const uid = useUserspace().uid;
    try {
        const tmp = await createInviteLink({data: standardInvite, uid});
        if((tmp.data as any).httpErrorCode)
            throw new Error((tmp.data as any).code)
        standardInviteLink.value = tmp.data;
        await Userspaces.Collection.updateDoc(props.user.$id!, {
            standardInviteLink: standardInviteLink.value.$id
        })
        emit('close')
        // console.log("Invite Instance", inviteInstance.value);
    } catch (e) {
        console.error('Error Creating Opt Invite:', e);
    }
    loading.value = false
}


// let userInitials = ref(((props.user?.name?.firstName?.[0] || '')+' '+(props.user?.name?.lastName?.[0] || '')).toUpperCase())

const __returned__ = { defaults, props, emit, loading, standardMeeting, standardInviteLink, rate, updateRate, costLength, time, updateDuration, durationLength, updateStandardMeeting, createStandardMeeting, ref, onMounted, onBeforeMount, DataInstance, InviteLinks, Userspaces, meetingConstants, httpsCallable, functions, BackButton, computed, createInviteLink, useUserspace, useInvites }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})